<template>
  <div class="apply_electronic">
    <el-container>
      <el-header style="height: 100px">
        <Head></Head>
      </el-header>
      <el-main class="security_main_body">
        <div class="security_main_body_div">
          <div class="security_main_body_div_H1">电子商务</div>
          <div class="security_main_body_div_text">
            借助奇迹ip强大的数据基础架构和代理资源，实时获取全球电子商务数据，让您的跨境业务畅行无阻
          </div>
          <div class="security_main_body_div_butts">
            <div class="security_main_body_div_butt div_buttA" @click="loginshow">免费试用</div>
            <div class="security_main_body_div_butt div_buttB" @click="topay">产品价格</div>
          </div>
          <div class="apply_electronic_dzsw_d4">
            <div>
              <img
                src="http://apiupss.ppfly.top/images/banner_icon1.svg"
                alt=""
              />
              <div>全球地区覆盖</div>
            </div>
            <div>
              <img
                src="http://apiupss.ppfly.top/images/banner_icon2.svg"
                alt=""
              />
              <div>99.9%业务成功率</div>
            </div>
            <div>
              <img
                src="http://apiupss.ppfly.top/images/banner_icon3.svg"
                alt=""
              />
              <div>精准定位州/城市</div>
            </div>
            <div>
              <img
                src="http://apiupss.ppfly.top/images/banner_icon4.svg"
                alt=""
              />
              <div>无限并发会话</div>
            </div>
          </div>
        </div>

        <div class="security_main_body_divB">
          <div class="security_main_body_divB_div">
            <div class="security_main_body_divB_div_left">
              <div>
                <div class="security_main_body_divB_div_left_H1">
                  竞争对手监控
                </div>
                <div class="security_main_body_divB_div_left_text">
                  快速收集竞争对手公开数据信息，制定更具竞争力的营销策略
                </div>
              </div>
              <div>
                <div class="applyele_list_img">
                  <div>
                    <img
                      src="http://apiupss.ppfly.top/images/tip_icon2.svg"
                      alt=""
                    />
                  </div>
                  <div>
                    <div>产品分析</div>
                    <div class="applyele_list_img_text">
                      获取产品类目、页面内容、销量及库存等信息，分析市场需求，优化运营策略
                    </div>
                  </div>
                </div>
                <div class="applyele_list_img">
                  <div>
                    <img
                      src="http://apiupss.ppfly.top/images/tip_icon2.svg"
                      alt=""
                    />
                  </div>
                  <div>
                    <div>价格对比</div>
                    <div class="applyele_list_img_text">
                      分析竞争对手的定价策略，及时调整自身价格以提高产品竞争力
                    </div>
                  </div>
                </div>
                <div class="applyele_list_img">
                  <div>
                    <img
                      src="http://apiupss.ppfly.top/images/tip_icon2.svg"
                      alt=""
                    />
                  </div>
                  <div>
                    <div>促销活动</div>
                    <div class="applyele_list_img_text">
                      监控竞对产品的折扣活动情况，制定有针对性的促销策略，吸引消费者
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="security_main_body_divB_div_reft">
              <img
                src="http://apiupss.ppfly.top/images/introduce_r_2.svg"
                alt=""
              />
            </div>
          </div>
        </div>

        <apply_electronic_main />
        <Footer></Footer>
      </el-main>
    </el-container>
    <Xuanfuret></Xuanfuret>
  </div>
</template>
<script>
import Head from "@/components/head/head.vue";
import Footer from "@/components/footer/footer.vue";
import Xuanfuret from "@/components/xuanfuret/xuanfuret.vue";
import apply_electronic_main from "@/components/apply_electronic_main/apply_electronic_main.vue";
export default {
  // apply-market
  name: "apply_electronic",
  components: {
    Head,
    Footer,
    Xuanfuret,
    apply_electronic_main,
  },
  data() {
    return {};
  },
  methods: {
    totop() {
      // 滚动到顶部的逻辑
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    topay(){
      this.$router
          .push({
            path: "/pay",
          })
          .catch((err) => {
            if (err.name !== "NavigationDuplicated") {
              // 处理其他错误
              console.error(err);
            }
          });
        this.$router.go(0);
    },
    loginshow() {
      const token = this.$cookies.get("userdata");
      if (token == null) {
        this.$router
          .push({
            path: "/userlogin",
          })
          .catch((err) => {
            if (err.name !== "NavigationDuplicated") {
              // 处理其他错误
              console.error(err);
            }
          });
      }
    },
  },

  created() {

  },
  mounted() {
    this.totop()
  },
};
</script>
<style lang="scss" scoped>
.security_main_body{
  background-color: #f5f2f23a;
}
.security_main_body_div {
  background: url(http://apiupss.ppfly.top/images/buy-banner.bb39d3b.png);
  background-color: #edf3fc;
  background-repeat: no-repeat;
  padding-bottom: 50px;
  // https://oss.kookeey.com/keekooy-next-dist/public/_nuxt/proxy-network_bg.1d9685a0.png
}
.security_main_body_div_H1 {
  padding-top: 80px;
  font-family: SourceHanSansCN-Medium;
  font-weight: 500;
  font-size: 54px;
  color: #1b2336;
  line-height: 76px;
}
.security_main_body_div_text {
  font-family: SourceHanSansCN-Regular;
  font-weight: 400;
  font-size: 22px;
  color: rgba(18, 17, 39, 0.72);
  line-height: 40px;
  max-width: 865px;
  margin: 31px auto 0;
}
.apply_electronic_dzsw_d4 {
  width: 60%;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
}
.security_main_body_div_butts {
  display: flex;
  justify-content: center;
  margin: 80px 0 80px 0;
}

.security_main_body_div_butt {
  width: 191px;
  height: 54px;
  border-radius: 45px;
  font-family: SourceHanSansCN-Medium;
  font-size: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 14px;
  cursor: pointer;
  box-sizing: border-box;
}
.div_buttA {
  background: #3580ff;
  color: #edf3fc;
}
.div_buttB {
  background: transparent;
  border: 1px solid #0e1d3c;
  color: #0e1d3c;
}
.security_main_body_divB {
  margin-top: 200px;
}
.security_main_body_divB_div {
  width: 70%;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  padding: 0 0 0 60px;
  background-color: #edf3fc;
  border-radius: 10px;
}
.security_main_body_divB_div_left {
  width: 50%;
  padding-top: 75px;
}
.security_main_body_divB_div_reft {
  width: 50%;
  margin-top: 60px;
}
.security_main_body_divB_div_left_H1 {
  font-family: SourceHanSansCN-Medium;
  font-weight: 400;
  font-size: 36px;
  color: #1b2336;
  line-height: 40px;
  text-align: left;
}
.security_main_body_divB_div_left_text {
  font-family: SourceHanSansCN-Regular;
  font-weight: 400;
  font-size: 16px;
  color: #565656;
  line-height: 26px;
  margin-top: 34px;
  margin-bottom: 24px;
  text-align: left;
}
.applyele_list_img {
  display: flex;
  justify-content: left;
  margin: 10px 0 10px 0;
}
.applyele_list_img > div {
  text-align: left;
  margin-right: 20px;
}
.applyele_list_img > div:nth-child(1) {
  text-align: left;
  margin-top: 7px;
}
.applyele_list_img_text {
  font-weight: 400;
  font-size: 14px;
  color: #565656;
  margin-top: 5px;
}
</style>
